module.exports = __webpack_public_path__ + "static/media/icon-lighting.5971c5b7.svg";